import React from "react";
import shoppingAnimation from "../../../image/sopping.json";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBoxesStacked,
  faFileInvoice,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import Lottie from "lottie-react";
import useWindowDimensions from "../../../helpers/useWindowDimensions";

function HeaderTitle() {
  const { width, height } = useWindowDimensions();
  return (
    <div className="Contain">
      <div
        className="live-list"
        >
        <div className="baner">
          <FontAwesomeIcon
            icon={faFileInvoice}
            style={{
              width: "32px",
              height: "32px",
              marginRight: "10px",
            }}
          />
          <span style={{ fontSize: "22px" }}>ຈັດການອໍເດີ ແຊວເພຈ </span>
        </div>
        <p>
          ລາຍການອໍເດີ້ ຈາກເຊວເພຈ ແລະ ມາຈາກ ອາຟຣິລີເອດ ນາຍໜ້າຂາຍ
        </p>
        {/* <button
          className="btn-create"
          style={{
            border: "none",
          }}
        >
          <FontAwesomeIcon icon={faPlus} style={{ marginRight: "10px" }} />
          ສ້າງອໍເດີ້
        </button> */}
      </div>

      {/* {width > 700 && (
        <div style={{ marginRight: "72px" }}>
          <Lottie
            animationData={shoppingAnimation}
            loop={true}
            style={{
              width: "247px",
              height: "169px",
            }}
          />
        </div>
      )} */}
    </div>
  );
}

export default HeaderTitle;
